<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="mb-2 float-end">
              <b-button v-b-modal.new-unit size="sm" variant="primary"><i class="mdi mdi-plus"></i> New Product Unit</b-button>
            </div>
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table
                :items="Items"
                :fields="Fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="Filtered"
                :busy="IsBusy"
              >
                <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(product)="data">
                  {{ data.item.product.name }}
                </template>
                <template #cell(unit)="data">
                  {{ data.item.unit.unit_name }}
                </template>
                <template #cell(allow_dispense)="data">
                  <span :class="['status-pill', data.item.allow_dispense ? 'enabled' : 'disabled']">
                    <span class="status-dot"></span>
                    <span>{{ data.item.allow_dispense ? "Yes" : "No" }}</span>
                  </span>
                </template>
                <template #cell(allow_sale)="data">
                  <span :class="['status-pill', data.item.allow_sale ? 'enabled' : 'disabled']">
                    <span class="status-dot"></span>
                    <span>{{ data.item.allow_sale ? "Yes" : "No" }}</span>
                  </span>
                </template>
                <template #cell(allow_purchase)="data">
                  <span :class="['status-pill', data.item.allow_purchase ? 'enabled' : 'disabled']">
                    <span class="status-dot"></span>
                    <span>{{ data.item.allow_purchase ? "Yes" : "No" }}</span>
                  </span>
                </template>
                <template #cell(actions)="data">
                  <div class="btn-group">
                    <b-button
                      @click="edit(data.item)"
                      type="button"
                      class="btn-sm btn"
                      variant="primary"
                      v-b-modal.edit
                    >
                      <i class="mdi mdi-square-edit-outline"></i>
                    </b-button>
                    <b-button @click="remove(data.item.id,data.item.product.name)" type="button" class="btn-sm btn" variant="danger" v-b-modal.delete>
                      <i class="mdi mdi-trash-can"></i>
                    </b-button>
                  </div>
                </template>
              </b-table>
              <div class="total-payments">
                <strong>Total Buying Price:</strong> {{ commas(totalbuyingprice) }}
                <span class="horizontal-separator"></span>
                <strong>Total Retail Price:</strong> {{ commas(totalretailprice) }}
                <span class="horizontal-separator"></span>
                <strong>Total Wholesale Price:</strong> {{ commas(totalwholesaleprice) }}
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="new-unit" centered title="New Product Unit" title-class="font-18" hide-footer modal-class="product-unit-modal">
      <div class="app-modal-banner">
        <div class="app-modal-banner-icon">
          <i class="mdi mdi-currency-usd"></i>
        </div>
        <div class="app-modal-banner-copy">
          <div class="app-modal-banner-title">Configure a new pricing unit</div>
          <div class="app-modal-banner-sub">
            Hover the <i class="mdi mdi-information-outline"></i> next to any field to see what it means.
          </div>
        </div>
      </div>
      <form @submit.prevent="addUnit">
        <div class="app-section">
          <div class="app-section-title">Identity</div>
          <div class="form-group mb-2">
            <label class="field-label" for="piu-input-product">
              <span>Product</span>
              <i class="mdi mdi-information-outline help-icon" id="piu-help-product" tabindex="0"></i>
            </label>
            <b-popover id="popover-piu-product" target="piu-help-product" triggers="hover focus" placement="right" custom-class="app-help-popover">
              <template #title>
                <div class="app-help-popover-titlebar">
                  <span>About: Product</span>
                  <button type="button" class="app-help-popover-close" aria-label="Close" @click="closeHelp('popover-piu-product')"><i class="mdi mdi-close"></i></button>
                </div>
              </template>
              The medicine this pricing unit belongs to. Each product can have multiple pricing units (one per pack level), so make sure you pick the right product before configuring the prices below.
            </b-popover>
            <multiselect
              id="piu-input-product"
              v-model="product"
              :options="products"
              label="name"
              track-by="id"
              placeholder="Select product"
              :show-labels="false"
            ></multiselect>
          </div>
          <div class="form-group mb-2">
            <label class="field-label" for="piu-input-unit">
              <span>Unit</span>
              <i class="mdi mdi-information-outline help-icon" id="piu-help-unit" tabindex="0"></i>
            </label>
            <b-popover id="popover-piu-unit" target="piu-help-unit" triggers="hover focus" placement="right" custom-class="app-help-popover">
              <template #title>
                <div class="app-help-popover-titlebar">
                  <span>About: Unit</span>
                  <button type="button" class="app-help-popover-close" aria-label="Close" @click="closeHelp('popover-piu-unit')"><i class="mdi mdi-close"></i></button>
                </div>
              </template>
              The pack level for this pricing entry &mdash; for example <strong>tablet</strong>, <strong>strip</strong>, <strong>box</strong> or <strong>bottle</strong>. Units are managed under <strong>Product Units</strong>.
            </b-popover>
            <multiselect
              id="piu-input-unit"
              v-model="unit"
              :options="productunits"
              label="name"
              track-by="id"
              placeholder="Select unit"
              :show-labels="false"
            ></multiselect>
          </div>
        </div>

        <div class="app-section">
          <div class="app-section-title">Pricing</div>
          <div class="row compact-form-row">
            <div class="col-md-6">
              <div class="form-group mb-2">
                <label class="field-label" for="piu-input-retail">
                  <span>Retail Price</span>
                  <i class="mdi mdi-information-outline help-icon" id="piu-help-retail" tabindex="0"></i>
                </label>
                <b-popover id="popover-piu-retail" target="piu-help-retail" triggers="hover focus" placement="right" custom-class="app-help-popover">
                  <template #title>
                    <div class="app-help-popover-titlebar">
                      <span>About: Retail Price</span>
                      <button type="button" class="app-help-popover-close" aria-label="Close" @click="closeHelp('popover-piu-retail')"><i class="mdi mdi-close"></i></button>
                    </div>
                  </template>
                  Price used when dispensing prescriptions and for normal walk-in retail sales. Enter the amount per <strong>one</strong> of this unit (e.g. one strip).
                </b-popover>
                <input id="piu-input-retail" v-model="retail_price" type="number" required class="form-control" />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group mb-2">
                <label class="field-label" for="piu-input-wholesale">
                  <span>Wholesale Price</span>
                  <i class="mdi mdi-information-outline help-icon" id="piu-help-wholesale" tabindex="0"></i>
                </label>
                <b-popover id="popover-piu-wholesale" target="piu-help-wholesale" triggers="hover focus" placement="right" custom-class="app-help-popover">
                  <template #title>
                    <div class="app-help-popover-titlebar">
                      <span>About: Wholesale Price</span>
                      <button type="button" class="app-help-popover-close" aria-label="Close" @click="closeHelp('popover-piu-wholesale')"><i class="mdi mdi-close"></i></button>
                    </div>
                  </template>
                  Price used only when the cashier explicitly selects <strong>Wholesale</strong> on a sale. Usually lower than retail because it's for bulk buyers.
                </b-popover>
                <input id="piu-input-wholesale" v-model="wholesale_price" type="number" required class="form-control" />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group mb-2">
                <label class="field-label" for="piu-input-buying">
                  <span>Buying Price</span>
                  <i class="mdi mdi-information-outline help-icon" id="piu-help-buying" tabindex="0"></i>
                </label>
                <b-popover id="popover-piu-buying" target="piu-help-buying" triggers="hover focus" placement="right" custom-class="app-help-popover">
                  <template #title>
                    <div class="app-help-popover-titlebar">
                      <span>About: Buying Price</span>
                      <button type="button" class="app-help-popover-close" aria-label="Close" @click="closeHelp('popover-piu-buying')"><i class="mdi mdi-close"></i></button>
                    </div>
                  </template>
                  The cost you pay the supplier to obtain one of this unit. Used for profit calculations and stock valuation &mdash; not visible to customers.
                </b-popover>
                <input id="piu-input-buying" v-model="buyingprice" type="number" required class="form-control" />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group mb-2">
                <label class="field-label" for="piu-input-base">
                  <span>Base Quantity</span>
                  <i class="mdi mdi-information-outline help-icon" id="piu-help-base" tabindex="0"></i>
                </label>
                <b-popover id="popover-piu-base" target="piu-help-base" triggers="hover focus" placement="right" custom-class="app-help-popover">
                  <template #title>
                    <div class="app-help-popover-titlebar">
                      <span>About: Base Quantity</span>
                      <button type="button" class="app-help-popover-close" aria-label="Close" @click="closeHelp('popover-piu-base')"><i class="mdi mdi-close"></i></button>
                    </div>
                  </template>
                  How many of the <strong>smallest unit</strong> are inside this unit. Examples: 1 strip = 10 tablets &rarr; enter <strong>10</strong>; 1 box = 20 strips of 10 = 200 tablets &rarr; enter <strong>200</strong>. The system uses this for FEFO and stock conversions.
                </b-popover>
                <input id="piu-input-base" v-model="base_quantity" type="number" required min="1" class="form-control" />
              </div>
            </div>
          </div>
        </div>

        <div class="app-section">
          <div class="app-section-title">Permissions</div>
          <div class="row permission-switch-grid">
            <div class="col-md-4">
              <label class="field-label field-label-switch compact-switch-row">
                <span>Allow Dispensing</span>
                <i class="mdi mdi-information-outline help-icon" id="piu-help-dispense" tabindex="0"></i>
              </label>
              <div class="permission-rocker">
                <RockerSwitch :value="allow_dispense" @change="allow_dispense = $event" />
              </div>
              <b-popover id="popover-piu-dispense" target="piu-help-dispense" triggers="hover focus" placement="top" custom-class="app-help-popover">
                <template #title>
                  <div class="app-help-popover-titlebar">
                    <span>About: Allow Dispensing</span>
                    <button type="button" class="app-help-popover-close" aria-label="Close" @click="closeHelp('popover-piu-dispense')"><i class="mdi mdi-close"></i></button>
                  </div>
                </template>
                Turn on if this unit can be issued to patients via the Dispense flow. Most pack-level units (e.g. strip, tablet) should be on; bulk units like a full box may be off.
              </b-popover>
            </div>
            <div class="col-md-4">
              <label class="field-label field-label-switch compact-switch-row">
                <span>Allow Selling</span>
                <i class="mdi mdi-information-outline help-icon" id="piu-help-sale" tabindex="0"></i>
              </label>
              <div class="permission-rocker">
                <RockerSwitch :value="allow_sale" @change="allow_sale = $event" />
              </div>
              <b-popover id="popover-piu-sale" target="piu-help-sale" triggers="hover focus" placement="top" custom-class="app-help-popover">
                <template #title>
                  <div class="app-help-popover-titlebar">
                    <span>About: Allow Selling</span>
                    <button type="button" class="app-help-popover-close" aria-label="Close" @click="closeHelp('popover-piu-sale')"><i class="mdi mdi-close"></i></button>
                  </div>
                </template>
                Turn on if this unit can be sold at the counter. Off-the-counter products typically need this on for at least one unit.
              </b-popover>
            </div>
            <div class="col-md-4">
              <label class="field-label field-label-switch compact-switch-row">
                <span>Allow Purchasing</span>
                <i class="mdi mdi-information-outline help-icon" id="piu-help-purchase" tabindex="0"></i>
              </label>
              <div class="permission-rocker">
                <RockerSwitch :value="allow_purchase" @change="allow_purchase = $event" />
              </div>
              <b-popover id="popover-piu-purchase" target="piu-help-purchase" triggers="hover focus" placement="top" custom-class="app-help-popover">
                <template #title>
                  <div class="app-help-popover-titlebar">
                    <span>About: Allow Purchasing</span>
                    <button type="button" class="app-help-popover-close" aria-label="Close" @click="closeHelp('popover-piu-purchase')"><i class="mdi mdi-close"></i></button>
                  </div>
                </template>
                Turn on if stock can be received from suppliers in this unit. Usually the larger units (box, carton) have this on while the dispensable units (tablet, strip) have it off.
              </b-popover>
            </div>
          </div>
        </div>

        <div class="form-group d-flex justify-content-end mt-3">
          <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-unit')" :disabled="createSaving">Close</b-button>
          <b-button type="submit" class="btn ms-1 w-30" variant="primary" :disabled="createSaving">
            <b-spinner v-if="createSaving" small class="align-middle me-1"></b-spinner>
            <i v-else class="fas fa-check-circle"></i>
            {{ createSaving ? 'Saving...' : 'Submit' }}
          </b-button>
        </div>
      </form>
    </b-modal>

    <b-modal id="edit-unit" centered title="Edit Product Unit" title-class="font-14" hide-footer modal-class="product-unit-modal">
      <div class="app-modal-banner">
        <div class="app-modal-banner-icon">
          <i class="mdi mdi-clipboard-edit-outline"></i>
        </div>
        <div class="app-modal-banner-copy">
          <div class="app-modal-banner-title">Update this pricing unit</div>
          <div class="app-modal-banner-sub">
            Hover the <i class="mdi mdi-information-outline"></i> next to any field to see what it means.
          </div>
        </div>
      </div>
      <form @submit.prevent="editUnit">
        <input v-model="id" type="hidden">
        <div class="app-section">
          <div class="app-section-title">Identity</div>
          <div class="form-group mb-2">
            <label class="field-label" for="piu-edit-input-product">
              <span>Product</span>
              <i class="mdi mdi-information-outline help-icon" id="piu-edit-help-product" tabindex="0"></i>
            </label>
            <b-popover id="popover-piu-edit-product" target="piu-edit-help-product" triggers="hover focus" placement="right" custom-class="app-help-popover">
              <template #title>
                <div class="app-help-popover-titlebar">
                  <span>About: Product</span>
                  <button type="button" class="app-help-popover-close" aria-label="Close" @click="closeHelp('popover-piu-edit-product')"><i class="mdi mdi-close"></i></button>
                </div>
              </template>
              The medicine this pricing unit belongs to. Changing it here re-links the prices and conversions to a different product, so use with care.
            </b-popover>
            <multiselect
              id="piu-edit-input-product"
              v-model="product"
              :options="products"
              label="name"
              track-by="id"
              placeholder="Select product"
              :show-labels="false"
            ></multiselect>
          </div>
          <div class="form-group mb-2">
            <label class="field-label" for="piu-edit-input-unit">
              <span>Unit</span>
              <i class="mdi mdi-information-outline help-icon" id="piu-edit-help-unit" tabindex="0"></i>
            </label>
            <b-popover id="popover-piu-edit-unit" target="piu-edit-help-unit" triggers="hover focus" placement="right" custom-class="app-help-popover">
              <template #title>
                <div class="app-help-popover-titlebar">
                  <span>About: Unit</span>
                  <button type="button" class="app-help-popover-close" aria-label="Close" @click="closeHelp('popover-piu-edit-unit')"><i class="mdi mdi-close"></i></button>
                </div>
              </template>
              The pack level for this entry &mdash; for example <strong>tablet</strong>, <strong>strip</strong>, <strong>box</strong> or <strong>bottle</strong>.
            </b-popover>
            <multiselect
              id="piu-edit-input-unit"
              v-model="unit"
              :options="productunits"
              label="name"
              track-by="id"
              placeholder="Select unit"
              :show-labels="false"
            ></multiselect>
          </div>
        </div>

        <div class="app-section">
          <div class="app-section-title">Pricing</div>
          <div class="row compact-form-row">
            <div class="col-md-6">
              <div class="form-group mb-2">
                <label class="field-label" for="piu-edit-input-retail">
                  <span>Retail Price</span>
                  <i class="mdi mdi-information-outline help-icon" id="piu-edit-help-retail" tabindex="0"></i>
                </label>
                <b-popover id="popover-piu-edit-retail" target="piu-edit-help-retail" triggers="hover focus" placement="right" custom-class="app-help-popover">
                  <template #title>
                    <div class="app-help-popover-titlebar">
                      <span>About: Retail Price</span>
                      <button type="button" class="app-help-popover-close" aria-label="Close" @click="closeHelp('popover-piu-edit-retail')"><i class="mdi mdi-close"></i></button>
                    </div>
                  </template>
                  Price used when dispensing prescriptions and for normal retail sales. Updating it changes the price for all future sales of this unit.
                </b-popover>
                <input id="piu-edit-input-retail" v-model="retail_price" type="number" required class="form-control" />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group mb-2">
                <label class="field-label" for="piu-edit-input-wholesale">
                  <span>Wholesale Price</span>
                  <i class="mdi mdi-information-outline help-icon" id="piu-edit-help-wholesale" tabindex="0"></i>
                </label>
                <b-popover id="popover-piu-edit-wholesale" target="piu-edit-help-wholesale" triggers="hover focus" placement="right" custom-class="app-help-popover">
                  <template #title>
                    <div class="app-help-popover-titlebar">
                      <span>About: Wholesale Price</span>
                      <button type="button" class="app-help-popover-close" aria-label="Close" @click="closeHelp('popover-piu-edit-wholesale')"><i class="mdi mdi-close"></i></button>
                    </div>
                  </template>
                  Price used only when the cashier selects <strong>Wholesale</strong> at sale time. Usually lower than retail.
                </b-popover>
                <input id="piu-edit-input-wholesale" v-model="wholesale_price" type="number" required class="form-control" />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group mb-2">
                <label class="field-label" for="piu-edit-input-buying">
                  <span>Buying Price</span>
                  <i class="mdi mdi-information-outline help-icon" id="piu-edit-help-buying" tabindex="0"></i>
                </label>
                <b-popover id="popover-piu-edit-buying" target="piu-edit-help-buying" triggers="hover focus" placement="right" custom-class="app-help-popover">
                  <template #title>
                    <div class="app-help-popover-titlebar">
                      <span>About: Buying Price</span>
                      <button type="button" class="app-help-popover-close" aria-label="Close" @click="closeHelp('popover-piu-edit-buying')"><i class="mdi mdi-close"></i></button>
                    </div>
                  </template>
                  The cost you pay your supplier per unit. Used for profit calculations and stock valuation &mdash; not visible to customers.
                </b-popover>
                <input id="piu-edit-input-buying" v-model="buyingprice" type="number" required class="form-control" />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group mb-2">
                <label class="field-label" for="piu-edit-input-base">
                  <span>Base Quantity</span>
                  <i class="mdi mdi-information-outline help-icon" id="piu-edit-help-base" tabindex="0"></i>
                </label>
                <b-popover id="popover-piu-edit-base" target="piu-edit-help-base" triggers="hover focus" placement="right" custom-class="app-help-popover">
                  <template #title>
                    <div class="app-help-popover-titlebar">
                      <span>About: Base Quantity</span>
                      <button type="button" class="app-help-popover-close" aria-label="Close" @click="closeHelp('popover-piu-edit-base')"><i class="mdi mdi-close"></i></button>
                    </div>
                  </template>
                  How many of the <strong>smallest unit</strong> are inside this unit. Examples: 1 strip = 10 tablets &rarr; enter <strong>10</strong>; 1 box = 200 tablets &rarr; enter <strong>200</strong>. Used by FEFO and stock conversions.
                </b-popover>
                <input id="piu-edit-input-base" v-model="base_quantity" type="number" required min="1" class="form-control" />
              </div>
            </div>
          </div>
        </div>

        <div class="app-section">
          <div class="app-section-title">Permissions</div>
          <div class="row permission-switch-grid">
            <div class="col-md-4">
              <label class="field-label field-label-switch compact-switch-row">
                <span>Allow Dispensing</span>
                <i class="mdi mdi-information-outline help-icon" id="piu-edit-help-dispense" tabindex="0"></i>
              </label>
              <div class="permission-rocker">
                <RockerSwitch :value="allow_dispense" @change="allow_dispense = $event" />
              </div>
              <b-popover id="popover-piu-edit-dispense" target="piu-edit-help-dispense" triggers="hover focus" placement="top" custom-class="app-help-popover">
                <template #title>
                  <div class="app-help-popover-titlebar">
                    <span>About: Allow Dispensing</span>
                    <button type="button" class="app-help-popover-close" aria-label="Close" @click="closeHelp('popover-piu-edit-dispense')"><i class="mdi mdi-close"></i></button>
                  </div>
                </template>
                Turn on if this unit can be issued to patients via the Dispense flow.
              </b-popover>
            </div>
            <div class="col-md-4">
              <label class="field-label field-label-switch compact-switch-row">
                <span>Allow Selling</span>
                <i class="mdi mdi-information-outline help-icon" id="piu-edit-help-sale" tabindex="0"></i>
              </label>
              <div class="permission-rocker">
                <RockerSwitch :value="allow_sale" @change="allow_sale = $event" />
              </div>
              <b-popover id="popover-piu-edit-sale" target="piu-edit-help-sale" triggers="hover focus" placement="top" custom-class="app-help-popover">
                <template #title>
                  <div class="app-help-popover-titlebar">
                    <span>About: Allow Selling</span>
                    <button type="button" class="app-help-popover-close" aria-label="Close" @click="closeHelp('popover-piu-edit-sale')"><i class="mdi mdi-close"></i></button>
                  </div>
                </template>
                Turn on if this unit can be sold at the counter.
              </b-popover>
            </div>
            <div class="col-md-4">
              <label class="field-label field-label-switch compact-switch-row">
                <span>Allow Purchasing</span>
                <i class="mdi mdi-information-outline help-icon" id="piu-edit-help-purchase" tabindex="0"></i>
              </label>
              <div class="permission-rocker">
                <RockerSwitch :value="allow_purchase" @change="allow_purchase = $event" />
              </div>
              <b-popover id="popover-piu-edit-purchase" target="piu-edit-help-purchase" triggers="hover focus" placement="top" custom-class="app-help-popover">
                <template #title>
                  <div class="app-help-popover-titlebar">
                    <span>About: Allow Purchasing</span>
                    <button type="button" class="app-help-popover-close" aria-label="Close" @click="closeHelp('popover-piu-edit-purchase')"><i class="mdi mdi-close"></i></button>
                  </div>
                </template>
                Turn on if stock can be received from suppliers in this unit.
              </b-popover>
            </div>
          </div>
        </div>

        <div class="form-group d-flex justify-content-end mt-3">
          <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('edit-unit')" :disabled="editSaving">Close</b-button>
          <b-button type="submit" class="btn ms-1 w-30" variant="primary" :disabled="editSaving"><b-spinner v-if="editSaving" small class="align-middle me-1"></b-spinner><i v-else class="fas fa-check-circle"></i> {{ editSaving ? 'Saving...' : 'Submit' }}</b-button>
        </div>
      </form>
    </b-modal>

    <b-modal id="delete-unit" centered title="Delete Product Unit" title-class="font-18" hide-footer>
      <form @submit.prevent="removeUnit">
        <input v-model="id" type="hidden">
        Are you sure you want to delete the Product Unit for : <b>{{ product_name }}</b> ?
        <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('delete-unit')" :disabled="deleteSaving">Close</b-button>
          <b-button type="submit" class="btn ms-1 w-30" variant="primary" :disabled="deleteSaving"><b-spinner v-if="deleteSaving" small class="align-middle me-1"></b-spinner><i v-else class="fas fa-check-circle"></i> {{ deleteSaving ? 'Deleting...' : 'YES' }}</b-button>
        </div>
      </form>
    </b-modal>
  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import Multiselect from "vue-multiselect";
import RockerSwitch from "vue-rocker-switch";
import "vue-rocker-switch/dist/vue-rocker-switch.css";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { unitsMethods, productMethods, itemunitsMethods, itemunitsComputed, unitsComputed, productComputed } from "@/state/helpers";

export default {
  page: {
    title: "Product Unit Pricing",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout, PageHeader, Multiselect, RockerSwitch
  },
  data() {
    return {
      title: "Product Unit Pricing",
      items: [{ text: "Dashboard", to: "/" }, { text: "Product Unit Pricing", active: true }],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      filterOn: [],
      isBusy: true,
      fields: [
        { key: "index", label: "#", visible: true },
        { key: "id", label: "ID", visible: false },
        { key: "product", label: "Product Name", visible: true },
        { key: "unit", label: "Unit Name", visible: true },
        { key: "buyingprice", label: "Buying Price", visible: true },
        { key: "retail_price", label: "Retail Price", visible: true },
        { key: "wholesale_price", label: "Wholesale Price", visible: true },
        { key: "base_quantity", label: "Base Quantity", visible: true },
        { key: "allow_dispense", label: "Dispense", visible: true },
        { key: "allow_sale", label: "Sale", visible: true },
        { key: "allow_purchase", label: "Purchase", visible: true },
        { key: "addedby", label: "Added by", visible: true },
        { key: "addedon", label: "Added on", visible: true },
        { key: "actions", label: "Actions", visible: true },
      ],
      id: "",
      product: "",
      product_name: "",
      unit: "",
      buyingprice: "",
      retail_price: "",
      wholesale_price: "",
      base_quantity: "",
      allow_dispense: true,
      allow_sale: true,
      allow_purchase: true,
      createSaving: false,
      editSaving: false,
      deleteSaving: false,
    };
  },
  computed: {
    ...itemunitsComputed,
    ...unitsComputed,
    ...productComputed,
    List() { return this.productitemunits.length; },
    Fields() { return this.fields.filter(field => field.visible); },
    Items() { return this.productitemunits.map((d) => ({ ...d })); },
    IsBusy() { return this.productitemunits.length === 0; },
    totalbuyingprice() { return this.productitemunits.reduce((total, item) => total + Number(item.buyingprice || 0), 0); },
    totalretailprice() { return this.productitemunits.reduce((total, item) => total + Number(item.retail_price || 0), 0); },
    totalwholesaleprice() { return this.productitemunits.reduce((total, item) => total + Number(item.wholesale_price || 0), 0); },
  },
  mounted() {
    this.fetchItemUnits();
    this.fetchUnits();
    this.fetchProducts();
    this.TotalRows = this.productitemunits.length;
    this.isBusy = false;
    document.addEventListener("click", this.handleOutsideHelpClick);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleOutsideHelpClick);
  },
  methods: {
    ...itemunitsMethods,
    ...productMethods,
    ...unitsMethods,
    commas(x) { return Number(x || 0).toLocaleString(); },
    closeHelp(popoverId) {
      this.$root.$emit("bv::hide::popover", popoverId);
    },
    closeAllHelp() {
      this.$root.$emit("bv::hide::popover");
    },
    handleOutsideHelpClick(event) {
      const target = event.target;
      if (!target || !target.closest) return;
      if (target.closest(".help-icon") || target.closest(".app-help-popover")) {
        return;
      }
      this.closeAllHelp();
    },
    boolToInt(value) { return value ? 1 : 0; },
    resetForm() {
      this.id = "";
      this.product = "";
      this.product_name = "";
      this.unit = "";
      this.buyingprice = "";
      this.retail_price = "";
      this.wholesale_price = "";
      this.base_quantity = "";
      this.allow_dispense = true;
      this.allow_sale = true;
      this.allow_purchase = true;
    },
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    edit(item) {
      this.id = item.id;
      this.product = item.product;
      this.product_name = item.product.name;
      this.unit = item.unit;
      this.buyingprice = item.buyingprice;
      this.retail_price = item.retail_price;
      this.wholesale_price = item.wholesale_price;
      this.base_quantity = item.base_quantity;
      this.allow_dispense = !!item.allow_dispense;
      this.allow_sale = !!item.allow_sale;
      this.allow_purchase = !!item.allow_purchase;
      this.$bvModal.show("edit-unit");
    },
    remove(id, productName) {
      this.id = id;
      this.product_name = productName;
      this.$bvModal.show("delete-unit");
    },
    async addUnit() {
      this.createSaving = true;
      const formData = new FormData();
      formData.append("product", this.product?.id || "");
      formData.append("unit", this.unit?.id || "");
      formData.append("retail_price", this.retail_price);
      formData.append("wholesale_price", this.wholesale_price);
      formData.append("buyingprice", this.buyingprice);
      formData.append("base_quantity", this.base_quantity);
      formData.append("allow_dispense", this.boolToInt(this.allow_dispense));
      formData.append("allow_sale", this.boolToInt(this.allow_sale));
      formData.append("allow_purchase", this.boolToInt(this.allow_purchase));
      try {
        await axios.post("/recordproductunit", formData);
        this.fetchItemUnits();
        this.$bvModal.hide("new-unit");
        this.resetForm();
      } finally {
        this.createSaving = false;
      }
    },
    async editUnit() {
      this.editSaving = true;
      const formData = new FormData();
      formData.append("id", this.id);
      formData.append("product", this.product?.id || "");
      formData.append("unit", this.unit?.id || "");
      formData.append("retail_price", this.retail_price);
      formData.append("wholesale_price", this.wholesale_price);
      formData.append("buyingprice", this.buyingprice);
      formData.append("base_quantity", this.base_quantity);
      formData.append("allow_dispense", this.boolToInt(this.allow_dispense));
      formData.append("allow_sale", this.boolToInt(this.allow_sale));
      formData.append("allow_purchase", this.boolToInt(this.allow_purchase));
      try {
        await axios.post("/editproductunit", formData);
        this.fetchItemUnits();
        this.$bvModal.hide("edit-unit");
        this.resetForm();
      } finally {
        this.editSaving = false;
      }
    },
    async removeUnit() {
      this.deleteSaving = true;
      const formData = new FormData();
      formData.append("id", this.id);
      try {
        await axios.post("/deleteproductunit", formData);
        this.fetchItemUnits();
        this.$bvModal.hide("delete-unit");
        this.resetForm();
      } finally {
        this.deleteSaving = false;
      }
    },
  },
};
</script>

<style scoped>
.app-modal-banner {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 0.9rem;
  margin-bottom: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
}

.app-modal-banner-icon {
  width: 38px;
  height: 38px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 38px;
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  color: #ffffff;
  font-size: 1.1rem;
  box-shadow: 0 8px 18px rgba(20, 184, 166, 0.22);
}

.app-modal-banner-title {
  font-size: 0.92rem;
  font-weight: 800;
  color: #0f172a;
  line-height: 1.15;
}

.app-modal-banner-sub {
  margin-top: 0.15rem;
  font-size: 0.76rem;
  color: #475569;
  line-height: 1.35;
}

.app-modal-banner-sub i {
  color: #0f766e;
  font-size: 0.95rem;
  vertical-align: -2px;
}

.app-section {
  margin-bottom: 0.4rem;
  padding: 0;
  border: 0;
  background: transparent;
}

.app-section-title {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  margin: 0.5rem 0 0.45rem;
  font-size: 0.66rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #64748b;
}

.app-section-title::after {
  content: "";
  flex: 1;
  height: 1px;
  background: #e2e8f0;
}

.field-label {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  margin-bottom: 0.4rem;
  font-size: 0.84rem;
  font-weight: 600;
  color: #1f2937;
}

.field-label-switch {
  margin-bottom: 0.3rem;
}

.compact-form-row > [class*="col-"] {
  margin-bottom: 0.15rem;
}

.permission-switch-grid > [class*="col-"] {
  margin-bottom: 0.45rem;
}

.compact-switch-row {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  width: 100%;
  min-height: 38px;
  padding: 0.15rem 0;
  font-size: 0.84rem;
  font-weight: 600;
  color: #1f2937;
}

.compact-switch-row .custom-control {
  margin-bottom: 0;
}

.compact-switch-row .custom-control-label::before {
  top: 0.05rem;
}

.compact-switch-row .custom-control-label::after {
  top: calc(0.05rem + 2px);
}

.compact-switch-row .help-icon {
  margin-left: 0.1rem;
}

.permission-rocker {
  margin-top: 0.15rem;
}

.help-icon {
  font-size: 1rem;
  color: #94a3b8;
  cursor: help;
  transition: color 0.18s ease, transform 0.18s ease;
}

.help-icon:hover,
.help-icon:focus {
  color: #0f766e;
  transform: translateY(-1px);
  outline: none;
}

.horizontal-separator {
  margin: 0 15px;
}

.status-pill {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.18rem 0.6rem 0.18rem 0.5rem;
  border-radius: 999px;
  font-size: 0.74rem;
  font-weight: 600;
  line-height: 1.2;
  border: 1px solid transparent;
  background: transparent;
}

.status-dot {
  width: 7px;
  height: 7px;
  border-radius: 999px;
  flex: 0 0 7px;
}

.status-pill.enabled {
  background: rgba(34, 197, 94, 0.1);
  color: #166534;
}

.status-pill.enabled .status-dot {
  background: #22c55e;
  box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.18);
}

.status-pill.disabled {
  background: rgba(148, 163, 184, 0.18);
  color: #475569;
}

.status-pill.disabled .status-dot {
  background: #94a3b8;
  box-shadow: 0 0 0 3px rgba(148, 163, 184, 0.22);
}
</style>

<style>
.product-unit-modal .modal-dialog {
  max-width: 680px;
  width: calc(100% - 2rem);
}

.product-unit-modal .modal-body {
  padding-top: 0.85rem;
  padding-bottom: 0.9rem;
}

.product-unit-modal .multiselect {
  color: #1f2937;
}

.product-unit-modal .multiselect__tags,
.product-unit-modal .multiselect__content-wrapper,
.product-unit-modal .multiselect__content,
.product-unit-modal .multiselect__option {
  background: #ffffff;
  color: #1f2937;
}

.product-unit-modal .multiselect__single,
.product-unit-modal .multiselect__input,
.product-unit-modal .multiselect__placeholder {
  color: #1f2937;
  background: transparent;
}

.product-unit-modal .multiselect__option--highlight,
.product-unit-modal .multiselect__option--highlight:after {
  background: #0f766e;
  color: #ffffff;
}

.product-unit-modal .multiselect__option--selected {
  background: #ecfdf5;
  color: #065f46;
  font-weight: 600;
}

.app-help-popover.popover {
  max-width: 340px;
  min-width: 280px;
  border: 1px solid #cbd5e1;
  border-radius: 14px;
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.18);
  background: #ffffff;
  font-family: inherit;
}

.app-help-popover .popover-header {
  padding: 0.5rem 0.6rem 0.5rem 0.9rem;
  border-bottom: 1px solid #e2e8f0;
  border-top-left-radius: 13px;
  border-top-right-radius: 13px;
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  color: #ffffff;
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.01em;
}

.app-help-popover .popover-body {
  padding: 0.85rem 0.95rem;
  font-size: 0.85rem;
  line-height: 1.55;
  color: #1f2937;
}

.app-help-popover .popover-body strong {
  color: #0f766e;
  font-weight: 700;
}

.app-help-popover-titlebar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}

.app-help-popover-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 999px;
  border: 0;
  background: rgba(255, 255, 255, 0.2);
  color: #ffffff;
  font-size: 1rem;
  line-height: 1;
  padding: 0;
  cursor: pointer;
  transition: background-color 0.18s ease, transform 0.18s ease;
}

.app-help-popover-close:hover,
.app-help-popover-close:focus {
  background: rgba(255, 255, 255, 0.35);
  transform: scale(1.06);
  outline: none;
}

.app-help-popover-close i {
  font-size: 0.95rem;
}

.app-help-popover.bs-popover-right > .arrow::after,
.app-help-popover.bs-popover-auto[x-placement^="right"] > .arrow::after {
  border-right-color: #ffffff;
}

.app-help-popover.bs-popover-right > .arrow::before,
.app-help-popover.bs-popover-auto[x-placement^="right"] > .arrow::before {
  border-right-color: #cbd5e1;
}
</style>
